import { useState, useEffect } from 'react';
// import FormField from '../components/FormField';

const input = {
  background: 'none',
  border: '1px solid #444',
  color: 'white',
  padding: '10px 14px',
  fontSize: '0.9rem',
  width: '100%',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
};

export default function BoredRoom() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/.netlify/functions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'Bored Room' }),
      });
      if (!res.ok) throw new Error('Server error');
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // — CHECKOUT FORM (commented out) —
  // const [form, setForm] = useState({
  //   name: '', email: '', phone: '',
  //   address: '', city: '', province: '', postalCode: '', notes: '',
  // });
  // const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(false);
  // const [serverError, setServerError] = useState('');
  //
  // const validate = () => {
  //   const e = {};
  //   if (!form.name.trim()) e.name = 'Required';
  //   if (!form.email.trim()) e.email = 'Required';
  //   else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Invalid email';
  //   if (!form.address.trim()) e.address = 'Required';
  //   if (!form.city.trim()) e.city = 'Required';
  //   if (!form.province.trim()) e.province = 'Required';
  //   if (!form.postalCode.trim()) e.postalCode = 'Required';
  //   return e;
  // };
  //
  // const handleChange = ({ target: { name, value } }) => {
  //   setForm(prev => ({ ...prev, [name]: value }));
  //   if (errors[name]) setErrors(prev => ({ ...prev, [name]: undefined }));
  // };
  //
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const errs = validate();
  //   if (Object.keys(errs).length) { setErrors(errs); return; }
  //   setLoading(true);
  //   setServerError('');
  //   try {
  //     const res = await fetch('/.netlify/functions/create-checkout-session', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ product: 'bored-game', formData: form }),
  //     });
  //     const data = await res.json();
  //     if (!res.ok) throw new Error(data.error || 'Something went wrong');
  //     window.location.href = data.url;
  //   } catch (err) {
  //     setServerError(err.message);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div style={{
      color: 'white',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px 80px',
      boxSizing: 'border-box',
      overflow: 'hidden',
    }}>

      <p style={{ fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.8, margin: '0 0 8px', textShadow: '0 2px 12px rgba(0,0,0,0.9)' }}>
        Arcade Antics
      </p>
      <h1 style={{ fontSize: '2rem', margin: '0 0 10px', textShadow: '0 2px 20px rgba(0,0,0,1), 0 0 40px rgba(0,0,0,0.8)' }}>Bored Room</h1>
      <p style={{ opacity: 0.75, margin: '0 0 48px', fontSize: '0.9rem', maxWidth: '380px', textAlign: 'center', lineHeight: 1.6, textShadow: '0 2px 12px rgba(0,0,0,0.9)' }}>
        {/* The board game. Physical copy, ships directly to you. */}
        10 early test copies available. Sign up to learn more.
      </p>

      <div style={{ border: '1px solid #2a2a2a', padding: '32px', width: '100%', maxWidth: '480px', background: '#000' }}>
        {submitted ? (
          <p style={{ textAlign: 'center', opacity: 0.7, margin: 0, lineHeight: 1.7 }}>
            You're on the list. We'll let you know when it's available.
          </p>
        ) : (
          <>
            <p style={{ fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.45, margin: '0 0 20px' }}>
              Notify me when available
            </p>
            <form onSubmit={handleSubscribe} noValidate>
              <input
                style={{ ...input, marginBottom: '12px' }}
                type="email"
                value={email}
                onChange={e => { setEmail(e.target.value); setError(''); }}
                placeholder="you@example.com"
              />
              {error && (
                <p style={{ color: '#e87c2b', fontSize: '0.85rem', margin: '0 0 12px' }}>{error}</p>
              )}
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  background: loading ? 'none' : '#e87c2b',
                  border: '1px solid #e87c2b',
                  color: 'white',
                  padding: '14px 28px',
                  fontSize: '0.9rem',
                  letterSpacing: '0.08em',
                  cursor: loading ? 'default' : 'pointer',
                  marginTop: '4px',
                  opacity: loading ? 0.5 : 1,
                  transition: 'opacity 0.2s',
                  fontFamily: 'inherit',
                }}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </>
        )}

        {/* — CHECKOUT FORM (commented out) —
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #2a2a2a',
          paddingBottom: '20px',
          marginBottom: '28px',
        }}>
          <span style={{ fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.45 }}>
            Board Game — 1 copy
          </span>
          <span style={{ fontSize: '1.4rem', letterSpacing: '0.02em' }}>
            $35 <span style={{ fontSize: '0.75rem', opacity: 0.4 }}>CAD</span>
          </span>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <FormField label="Full Name *" error={errors.name}>
            <input style={input} name="name" value={form.name} onChange={handleChange} placeholder="Jane Smith" />
          </FormField>
          <FormField label="Email *" error={errors.email}>
            <input style={input} name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
          </FormField>
          <FormField label="Phone (optional)">
            <input style={input} name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="+1 (416) 555-0000" />
          </FormField>
          <p style={{
            fontSize: '0.7rem',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            opacity: 0.35,
            margin: '8px 0 20px',
            borderTop: '1px solid #2a2a2a',
            paddingTop: '20px',
          }}>
            Shipping Address
          </p>
          <FormField label="Street Address *" error={errors.address}>
            <input style={input} name="address" value={form.address} onChange={handleChange} placeholder="123 Main St" />
          </FormField>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 90px', gap: '12px' }}>
            <FormField label="City *" error={errors.city}>
              <input style={input} name="city" value={form.city} onChange={handleChange} placeholder="Toronto" />
            </FormField>
            <FormField label="Province *" error={errors.province}>
              <input style={input} name="province" value={form.province} onChange={handleChange} placeholder="ON" />
            </FormField>
          </div>
          <FormField label="Postal Code *" error={errors.postalCode}>
            <input style={{ ...input, maxWidth: '160px' }} name="postalCode" value={form.postalCode} onChange={handleChange} placeholder="M5V 3A8" />
          </FormField>
          <FormField label="Order Notes (optional)">
            <textarea
              style={{ ...input, resize: 'vertical', minHeight: '80px' }}
              name="notes"
              value={form.notes}
              onChange={handleChange}
              placeholder="Any special requests..."
            />
          </FormField>
          {serverError && (
            <p style={{ color: '#e87c2b', fontSize: '0.85rem', margin: '0 0 16px' }}>{serverError}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? 'none' : '#e87c2b',
              border: '1px solid #e87c2b',
              color: 'white',
              padding: '14px 28px',
              fontSize: '0.9rem',
              letterSpacing: '0.08em',
              cursor: loading ? 'default' : 'pointer',
              marginTop: '8px',
              opacity: loading ? 0.5 : 1,
              transition: 'opacity 0.2s',
              fontFamily: 'inherit',
            }}
          >
            {loading ? 'Redirecting...' : 'Proceed to Checkout — $35.00 CAD'}
          </button>
        </form>
        */}
      </div>
    </div>
  );
}
